import whiteLogo from "../assest/images/whitelogo.png";
import visaLogo from "../assest/images/visa-logo.png";
import mastercardLogo from "../assest/images/Mastercard.png";
import paypalLogo from "../assest/images/PayPal.png";
import applePayLogo from "../assest/images/ApplePay.png";
import bitcoinLogo from "../assest/images/Bitcoin.png";
import googlePayLogo from "../assest/images/GooglePay.png";
import unionPayLogo from "../assest/images/UnionPay.png";
import giropayLogo from "../assest/images/giropay.png";
import idealLogo from "../assest/images/Ideal.png";
import bancontactLogo from "../assest/images/Bancontact.png";
import ApiCall from "../common/ApiCall";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import helper from "../common/Helper";
import { footerSocialUrl } from "../common/Config";
import moment from "moment";

const Footer = () => {

    const [footerSettings, setFooterSettings] = useState([])
    const [loading, setLoading] = useState(false)
    const user = useSelector((state) => state.user);

    const getSettingsList = async () => {
        setLoading(true)
        const getList = await ApiCall('get', 'footer-settings', null, user.token)
        setLoading(false)
        if (getList) {
            if (getList?.data?.success) {
                setFooterSettings(getList.data.settings)
            }
        }
    }

    useEffect(() => {
        (async () => {
            await getSettingsList();
        })();
    }, []);

    // Support portal URL (env-driven). Used by the "Need Help?" card instead of a mailto link.
    const supportUrl = (process.env.REACT_APP_SUPPORT_URL || "http://localhost:8002").replace(/\/$/, "");

    const paymentMethods = [
        { src: visaLogo, alt: 'Visa' },
        { src: mastercardLogo, alt: 'Mastercard' },
        { src: paypalLogo, alt: 'PayPal' },
        { src: applePayLogo, alt: 'Apple Pay' },
        { src: bitcoinLogo, alt: 'Bitcoin' },
        { src: googlePayLogo, alt: 'Google Pay' },
        { src: unionPayLogo, alt: 'Union Pay' },
        { src: giropayLogo, alt: 'Giropay' },
        { src: idealLogo, alt: 'Ideal' },
        { src: bancontactLogo, alt: 'Bancontact' }
    ];

    const socialFields = Object.fromEntries(
        Object.entries(footerSettings).filter(([key]) => key.startsWith("footer_social_"))
    );

    const supportLinks = [
        { label: 'About Us', url: helper.touristUrl + '/about-us' },
        { label: 'FAQ', url: helper.touristUrl + '/faqs' },
        { label: 'Travel guides', url: helper.touristUrl + '/blog' },
        { label: 'Contact Us', url: helper.touristUrl + '/contact-us' },
        { label: 'Terms and Conditions', url: helper.touristUrl + '/terms-and-conditions' },
        { label: 'Things To Do In...', url: helper.touristUrl + '/travel-guide' },
        { label: 'Influencer Program', url: helper.touristUrl + '/influencer-program' },
    ];

    const footerIcons = footerSettings['footer_icons'] && footerSettings['footer_icons'] != ""
        ? JSON.parse(footerSettings['footer_icons'])
        : [];

    return (
        <footer>
            <div className="footerPart txFooter">
                <div className="container">
                    <div className="footerBox">
                        <div className="txFooterGrid">

                            {/* Brand */}
                            <div className="txFooterBrand">
                                <a href="javascript:void(0)" className="txFooterLogo">
                                    <img src={whiteLogo} alt="ToursXplorer" />
                                </a>
                                {
                                    loading ?
                                        <p className="skeleton">
                                            KMG – MOBILIDADE URBANA, S.A If you have an inquiry or would like more information about any of our tours, please use the contact form below! We will get back to you within 24 hours.
                                        </p> :
                                        <p>{footerSettings['footer_description']}</p>
                                }
                            </div>

                            {/* Support links */}
                            <div className="txFooterSupport">
                                <h4>Support</h4>
                                <ul>
                                    {
                                        supportLinks.map((link) => (
                                            <li key={link.label}>
                                                <a target="_blank" rel="noreferrer" href={link.url}>
                                                    <span>{link.label}</span>
                                                    <i className="fa-solid fa-angle-right"></i>
                                                </a>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>

                            {/* Need Help card */}
                            <div className="txFooterHelp">
                                <a href={supportUrl} target="_blank" rel="noreferrer" className="txHelpCard">
                                    <span className="txHelpIcon">
                                        <i className="fa-solid fa-headset"></i>
                                    </span>
                                    <span className="txHelpBody">
                                        <span className="txHelpTitle">Need Help?</span>
                                        <span className="txHelpDesc">We're here for you</span>
                                        <span className="txHelpLink">Visit Support Center</span>
                                    </span>
                                </a>
                            </div>

                            {/* Stay Connected */}
                            <div className="txFooterConnect">
                                <h4>Stay Connected</h4>
                                {
                                    Object.entries(socialFields).length > 0 &&
                                    <ul className="txSocial">
                                        {
                                            Object.entries(socialFields).map((v, k) => (
                                                v[1] != "" && v[1] != null &&
                                                <li key={k}>
                                                    <a target="_blank" rel="noreferrer"
                                                        aria-label={v[0]}
                                                        href={v[0] == 'footer_social_twitter_username' ? 'https://t.me/' + v[1] : v[1]}>
                                                        {footerSocialUrl[v[0]]}
                                                    </a>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                }
                                {
                                    loading ?
                                        <ul className="txPayment">
                                            {
                                                paymentMethods.map(({ src, alt }) => (
                                                    <li key={alt}>
                                                        <span className="skeleton">
                                                            <img src={src} alt={alt} loading="lazy" />
                                                        </span>
                                                    </li>
                                                ))
                                            }
                                        </ul> :
                                        footerIcons.length > 0 &&
                                        <ul className="txPayment">
                                            {
                                                footerIcons.map((src, alt) => (
                                                    <li key={alt}>
                                                        <span>
                                                            <img src={helper.S3Url + '/' + helper.footerImageDir + '/' + src} alt={String(alt)} loading="lazy" />
                                                        </span>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                }
                            </div>
                        </div>

                        <div className="copyRight txFooterBottom">
                            <p>{footerSettings['footer_copyrights']?.replace('[YEAR]', moment().format('YYYY'))}</p>
                            <p className="txSecure">
                                <i className="fa-solid fa-lock"></i>
                                <span>Secure payments powered by trusted partners</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )

}
export default Footer
